module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAXCAYAAAA7kX6CAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADOSURBVHgBndHBEYIwEAXQbApASsBO7IEDw0lasANK0AqUE8PJErQU7YATR/CHkUwkhtnNzgQ2Cy/LDtR13XGaprNSqieiuiiKRjFCA9W4p1gZ8ps5iAW/yAYXm46ndZGDyVzatq0w39V7SFSFZqYlkWJyNxJM65e42INc/BdycBCGMPb9MAx7rbbjifVyC/jHaZIkO73RLcPpD6SZWx/H8ZLn+ZskCN2asiyr+ZNjkAe56AdKkIVSNMMYZEID3aVohjFogY0U2cCcB7OUID6e4pl2IpkkuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/account/arrowForward@2x.png
// module id = 368
// module chunks = 0